// core version + navigation, pagination modules:
import Swiper, { Navigation, Pagination } from "swiper";

// configure Swiper to use modules
Swiper.use([Navigation, Pagination]);

(function () {
  const newsSlider = document.querySelectorAll(".news-slider");
  let newsSwiper = [];

  for (let i = 0; i < newsSlider.length; i++) {
    newsSwiper[i] = new Swiper(newsSlider[i], {
      loop: false,
      slidesPerView: 1,
      spaceBetween: 15,
      freeMode: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
        dynamicBullets: true,
        dynamicMainBullets: 3,
    },
      breakpoints: {
        768: {
          slidesPerView: 2,
        },
        1024: {
          slidesPerView: 3,
        },
        1580: {
            slidesPerView: 4,
        }
      },
    });
  }
})();
